import { StatusChip, type StatusKind } from "../ui-x";

/**
 * Record status is always a StatusChip (reference rule 15) — re-label rather
 * than recolour. This maps the app's status strings onto the six chip kinds and
 * keeps the original label, so every call site stays `<Status label={x} />`.
 */
const KIND_BY_STATUS: Record<string, StatusKind> = {
  active: "ready",
  open: "ready",
  finished: "ready",
  completed: "ready",
  paid: "ready",
  accepted: "ready",
  successful: "ready",
  successfull: "ready",

  "on-going": "progress",
  ongoing: "progress",
  pending: "progress",
  unpaid: "progress",
  processing: "progress",

  offered: "review",
  "to-start": "review",
  review: "review",

  closed: "exited",
  expired: "exited",

  declined: "suspended",
  rejected: "suspended",
  failed: "suspended",
  cancelled: "suspended",
  canceled: "suspended",
  suspended: "suspended",

  draft: "draft",
  "not verified": "draft",
};

const Status = ({ label }: { label?: string | number | null }) => {
  if (!label) return null;
  const kind = KIND_BY_STATUS[String(label).toLowerCase().trim()] ?? "draft";
  return <StatusChip status={kind} label={String(label)} className="capitalize" />;
};

export default Status;
